export const GET_ADVERTISMENT = "GET_ADVERTISMENT";
export const ADD_ADVERTISMENT = "ADD_ADVERTISMENT";
export const DELETE_ADVERTISMENT = "DELETE_ADVERTISMENT";
export const EDIT_ADVERTISMENT = "EDIT_ADVERTISMENT";
export const GET_REFERRAL = "GET_REFERRAL";
export const ADD_REFERRAL = "ADD_REFERRAL";
export const DELETE_REFERRAL = "DELETE_REFERRAL";
export const EDIT_REFERRAL = "EDIT_REFERRAL";
export const GET_ENGAGEMENT = "GET_ENGAGEMENT";
export const ADD_ENGAGEMENT = "ADD_ENGAGEMENT";
export const DELETE_ENGAGEMENT = "DELETE_ENGAGEMENT";
export const EDIT_ENGAGEMENT = "EDIT_ENGAGEMENT";
